import styled from 'styled-components';
import { rem, em } from 'polished';
import { Heading } from 'elements';
import { HeadingBase } from 'elements/Heading/styled';
import { colors } from 'core/theme';
import { media, Flex } from 'core/layout';

export const FlexGroup = Flex.extend`
  ${media.tablet`
    display: block;
  `};
`;

export const StyledHeading = styled(Heading)`
  margin-bottom: 1em !important;

  ${media.tabletSmall`
    font-size: ${rem(24)};
  `};
`;

export const StyledSmall = styled.small`
  color: ${colors.lightText};
  display: block;
  font-size: ${em(14, 36)};
  font-weight: normal;
  margin-top: 1em;

  & > span:not(:first-child) {
    margin-left: 1.5em;
  }

  ${media.tabletSmall`
    font-size: ${em(12, 24)};
  `};
`;

export const StyledContent = styled.article`
  h1:first-child {
    margin-bottom: 1em;
  }

  ${media.tabletSmall`
    font-size: ${16/18}rem;
  `};
`;

export const SubpageHeading = HeadingBase.withComponent('h2').extend`
  font-size: ${em(24)};
  margin-bottom: 1em;
`;



// WEBPACK FOOTER //
// ./src/pages/Raksts/styled.js